import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type CancelVaccinationReactionParams = PatientCommandParams & {
	vaccinationReaction: {
		previousVersion: NCZIExtension;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		createdAt: string;
		versionStatus: string;
		reason: string;
	};
};

export const CancelVaccinationReaction = (
	params: CancelVaccinationReactionParams,
): Command => {
	return {
		operation: 'StornujReakciuNaOckovanie',
		params,
	};
};
